export const LIVEKIT_START_COMPUTER_SCREEN_SHARE_EVENT = 'livekit-start-computer-screen-share'

export interface ComputerScreenShareRequestDetail {
  computerId: string
}

export interface ComputerScreenShareNetwork {
  disconnectFromComputer?: (computerId: string) => void
  onStopScreenShare?: (computerId: string) => void
}

export interface ComputerScreenShareRequestResolution {
  activeComputerId: string | null
  shouldStartScreenShare: boolean
}

export interface NativeComputerScreenShareIntent {
  computerId: string
}

export const LIVEKIT_NATIVE_COMPUTER_SCREEN_SHARE_INTENT_EVENT =
  'livekit-native-computer-screen-share-intent'

export function dispatchComputerScreenShareRequest(computerId: string): void {
  if (!computerId || typeof window === 'undefined') return

  window.dispatchEvent(
    new CustomEvent<ComputerScreenShareRequestDetail>(LIVEKIT_START_COMPUTER_SCREEN_SHARE_EVENT, {
      detail: { computerId },
    })
  )
}

export function dispatchNativeComputerScreenShareIntent(computerId: string): void {
  if (!computerId || typeof window === 'undefined') return

  window.dispatchEvent(
    new CustomEvent<NativeComputerScreenShareIntent>(
      LIVEKIT_NATIVE_COMPUTER_SCREEN_SHARE_INTENT_EVENT,
      {
        detail: { computerId },
      }
    )
  )
}

export function requestNativeComputerScreenShareFromSelectedItem(): boolean {
  if (typeof window === 'undefined') return false

  const phaserGame = (window as typeof window & {
    phaserGame?: {
      scene?: {
        keys?: {
          game?: {
            playerSelector?: {
              selectedItem?: {
                itemType?: number
                id?: string
                currentUsers?: Set<string>
              }
            }
          }
        }
      }
    }
  }).phaserGame

  const selectedItem = phaserGame?.scene?.keys?.game?.playerSelector?.selectedItem
  if (!selectedItem || selectedItem.itemType !== 3 || !selectedItem.id) {
    return false
  }

  const currentUsers = selectedItem.currentUsers
  if (currentUsers instanceof Set && currentUsers.size > 0) {
    return false
  }

  dispatchNativeComputerScreenShareIntent(selectedItem.id)
  return true
}

export function resolveComputerScreenShareRequest(
  requestedComputerId: string | null | undefined,
  options: {
    activeComputerId: string | null
    isScreenShareEnabled: boolean
    isScreenShareStarting?: boolean
  }
): ComputerScreenShareRequestResolution {
  if (!requestedComputerId) {
    return {
      activeComputerId: options.activeComputerId,
      shouldStartScreenShare: false,
    }
  }

  if (options.isScreenShareEnabled || options.isScreenShareStarting) {
    return {
      activeComputerId: options.activeComputerId,
      shouldStartScreenShare: false,
    }
  }

  return {
    activeComputerId: requestedComputerId,
    shouldStartScreenShare: true,
  }
}

export function releaseComputerScreenShare(
  network: ComputerScreenShareNetwork | null | undefined,
  computerId: string | null | undefined,
  options: { notifyStop?: boolean } = {}
): void {
  if (!network || !computerId) return

  if (options.notifyStop) {
    network.onStopScreenShare?.(computerId)
  }

  network.disconnectFromComputer?.(computerId)
}

export function clearActiveComputerScreenShare(
  network: ComputerScreenShareNetwork | null | undefined,
  computerId: string | null | undefined,
  options: { notifyStop?: boolean } = {}
): null {
  releaseComputerScreenShare(network, computerId, options)
  return null
}
